<script>
	import { projectSettings } from "../config";
	import { regFormEmail } from "../gtm";
</script>

<a
	title="Email {projectSettings.emailAddress}"
	href="mailto:{projectSettings.emailAddress}"
	on:click={() => regFormEmail(projectSettings.emailAddress)}
	target="_blank">
	{projectSettings.emailAddress}
</a>

<style>
	a {
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}
</style>
